import styled from 'styled-components';

const Container = styled.ul`
  list-style-type: disc;
  padding-left: 25px;

  li {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }
`;

export default Container;
